<template>
  <div>
    <div id="overlay" @click="closeReloadOverlay()" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"></div>
    <div class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20" style="width: 380px; height: 300px; left: calc((108vw - 500px)/2); top:200px;z-index: 99;">
      <div class="flex flex-col justify-center px-4 py-2">
        <img class="flex self-center mt-8" src="../../../assets/pending_queries.svg" style="width:90px;">
          <div class="flex flex-row mb-2 justify-between items-center" style="position: absolute;bottom: 94px; left:31%">
              <div class="align-center text-lg text-left font-semibold py-2" style="color:#70411b">Pending Queries</div>
          </div>
          <label class="text-grey-darker font-light text-xs mx-8 text-center" style="position: absolute; bottom: 74px; left: 10px; text-align:center">
            You have pending queries from your patients. Please complete the conversations to close them.
          </label>
          <div class="flex flex-row mt-3 mb-5 justify-start" style="position: absolute;bottom: 0px; left:31%; margin-left: 38px;">
              <div @click="closeReloadOverlay()" class="flex flex-col font-semibold bg-blue px-6 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md">Okay</div>
          </div>
      </div>
    </div>
  </div>  
</template>
<script>
export default {
  methods: {
    closeReloadOverlay: function () {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/modals/PendingQueries.vue